import { createContext, useContext } from 'react'

export interface ILinkedItem {
  id: string
  name: string
  infuseId?: string | null
}

export interface ResourceLinkContextValue {
  linkedItem: ILinkedItem | null
  availableTargets: ILinkedItem[]
  isPickerOpen: boolean
  openPicker: () => void
  closePicker: () => void
  linkTo: (targetId: string) => Promise<void>
  unlinkCurrent: () => Promise<void>
  loading: boolean
  error: string | null
}

export const ResourceLinkContext =
  createContext<ResourceLinkContextValue | null>(null)

export function useResourceLinkContext(): ResourceLinkContextValue {
  const context = useContext(ResourceLinkContext)
  if (!context) {
    throw new Error(
      'useResourceLinkContext must be used within ResourceLink.Root',
    )
  }
  return context
}
